import View from "./view";
import * as Components from "./components";
import { bind, css } from "./utils";
import { breakpoints } from "./config";

export default class Default extends View {
  defaultUI = {
    components: "[data-component]",
    animatePaths: ".js-animatePathLength",
    fcChangeElements: ".fc-change-with-previous",
  };
  defaultEvents = {
    animateout: "animateOut",
    animateoutend: "animateOutEnd",
    animatein: "animateIn",
    animateinend: "animateInEnd",
  };

  constructor(props) {
    super(props);

    //this.bind("fadeOut", "fadeIn"); // don't do the fadein and fadeout
  }

  init() {
    this.initComponents();
    this.initIcons();
    this.fixFlexibleContent();

    if (this.initilized) this.initilized();
  }

  // animateIn({ hash }) {
  //   //console.log("animateIn");
  //   this.opacity = 0;
  //   this.fadeIn();
  // }
  // animateInEnd() {
  //   //console.log("animateInEnd");
  //   css(this.el, {
  //     clearProps: "opacity",
  //   });
  // }

  initComponents() {
    this.ui.components.forEach((el) => {
      const name = el.dataset.component;
      const converted = name
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.substr(1))
        .join("");
      const Component = Components[converted];
      if (Component) {
        new Component({ el }).render();
      }
    });
  }

  /**
   * Inspired by https://jakearchibald.com/2013/animated-line-drawing-svg/
   */
  initIcons() {
    const paths = this.ui.animatePaths;
    paths.forEach((path, index) => {
      const length = path.getTotalLength();

      const keyframes = `
                @keyframes svgiconanimation${index} {
                    from {
                        stroke-dashoffset: ${length * 0.2};
                    }
                    to {
                        stroke-dashoffset: 0;
                    }
                }
            `;
      let style = document.createElement("style");
      style.type = "text/css";
      style.className = "js-keyframesStyleTag";
      style.innerHTML = keyframes;
      this.el.appendChild(style);
      path.style.strokeDasharray = length + " " + length;
      path.style.animation = `svgiconanimation${index} ease-in .4s infinite alternate`;
    });
  }

  // animateOut() {
  //   //console.log("animateOut");
  //   this.el.classList.add("is-animating-out");
  //   this.opacity = 1;
  //   this.fadeOut();
  // }

  // animateOutEnd() {
  //   //console.log("animateOutEnd");
  //   this.destroy();
  // }

  // fadeOut() {
  //   this.opacity -= 0.1;
  //   this.el.style.opacity = this.opacity;
  //   if (this.opacity > 0) {
  //     window.requestAnimationFrame(this.fadeOut);
  //   } else {
  //     this.trigger("animateoutend");
  //   }
  // }
  // fadeIn() {
  //   this.opacity += 0.1;
  //   this.el.style.opacity = this.opacity;
  //   if (this.opacity < 1) {
  //     window.requestAnimationFrame(this.fadeIn);
  //   } else {
  //     this.trigger("animate:in:end");
  //   }
  // }

  fixFlexibleContent() {
    this.ui.fcChangeElements.forEach((el) => {
      const prevSib = el.previousElementSibling;
      if (!prevSib) return;

      if (window.innerWidth < breakpoints.small) {
        const order = parseInt(window.getComputedStyle(el).order);
        el.dataset.originalOrder = order;
        el.style.order = order - 1;
        prevSib.style.order = order;
        el.dataset.originalOrder = order - 1;
        const clone = el.cloneNode(true);
        const prevClone = prevSib.cloneNode(true);
        el.replaceWith(prevClone);
        prevSib.replaceWith(clone);
        this.fcChangeElements = true;
      } else if (this.fcChangeElements) {
        el.style.order = el.dataset.originalOrder;
        prevSib.style.order = el.dataset.originalOrder;
        this.fcChangeElements = false;
      }
    });
  }
}
